module.exports = __webpack_public_path__ + "images/112_2048.jpg";